import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import SendLineMessageModel from "@/commons/models/SendLineMessage";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * メッセージ送信 API 操作クラス
 */
export default class SendOtherUserMessagesages {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * POST SendMessages
   */
  public async post(userStore: LoginUser, sendMessage: SendOtherUserMessagesagesPostModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.SendOtherUserGroupMessages, formatParams);
    const response = await this.commonService.executePost<any>(userStore, requestUrl, sendMessage, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface SendOtherUserMessagesagesPostModel {
  /** 宛先ソートキー */
  sortKeys: Array<string>;
  /** 宛先名 */
  targetName: string;
  /** タイトル */
  title: string;
  /** メッセージ */
  message: string;
  /** オプション文をつけるか */
  addOptionText: boolean;
  /** 見ましたをつけるか */
  addReadButton: boolean;
  /** 返信をつけるか */
  addReplyButton: boolean;
  /** 送信者ID */
  writerId: string;
  /** 送信者名 */
  writtenBy: string;
  /** 添付ファイルのS3URL */
  fileUrls: Array<string>;
  /** 添付ファイル名 */
  fileNames: Array<string>;
  /** 種別 */
  type: string;
}
